import { Question } from "../../types/Question";
import UserAvatar from "../generic/UserAvatar";
import IconText from "../generic/IconText";
import TagDisplay from "../generic/TagDisplay";
import UserName from "../generic/UserName";
import BasicMenu from "../generic/BasicMenu";
import { formatViews, truncateText } from "../../../common/utils/helper";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import RecommendIcon from "@mui/icons-material/Recommend";
import ChatIcon from "@mui/icons-material/Chat";
import BarChartIcon from "@mui/icons-material/BarChart";
import React from "react";
import { Link } from "react-router-dom";

interface QuestionItemProps {
    question: Question;
}

const QuestionItem: React.FC<QuestionItemProps> = ({ question }) => {
    const author = question.author;

    const options = {};

    return (
        <Card sx={{ display: "grid" }}>
            <CardActionArea component={Link} to={`/question/${question.id}`}>
                <CardHeader
                    avatar={<UserAvatar user={author} size={20} />}
                    action={<BasicMenu options={options} />}
                    title={<UserName user={author} />}
                    subheader={question.createdAt}
                    sx={{ textAlign: "left", paddingBottom: 0 }}
                />
                <CardContent sx={{ textAlign: "left", paddingLeft: 2, paddingBottom: 0 }}>
                    <Typography variant="h6" color={"black"} sx={{ fontWeight: "bold", fontSize: 16 }}>
                        {question.title}
                    </Typography>
                    <Typography variant="body2">{truncateText(question.body, 300)}</Typography>
                </CardContent>
                <CardActions sx={{ display: "grid", p: 1 }}>
                    {/* Tags */}
                    <TagDisplay tags={question.tags} />
                    {/* votes, answers, views */}
                    <Stack direction={"row"} spacing={3} color={"dimgray"} p={1}>
                        <IconText icon={<RecommendIcon />} text={question.votes.toString()} />
                        <IconText
                            icon={<ChatIcon color={question.acceptedAnswer !== -1 ? "success" : "inherit"} />}
                            text={question.answersCount.toString()}
                        />
                        <IconText icon={<BarChartIcon />} text={formatViews(question.views)} />
                    </Stack>
                </CardActions>
            </CardActionArea>
        </Card>
    );
};

export default QuestionItem;
